module.exports = __webpack_public_path__ + "img/temp.9e96d183.png";